// What Keeptouch Infinity really unlocks on the server. One list for the offer
// page and the paywall window, so the two cannot drift apart.
export const INFINITY_FEATURE_KEYS = [
  'subscription.infinityFeatureContacts',
  'subscription.infinityFeatureNotes',
  'subscription.infinityFeatureReminders',
  'subscription.infinityFeatureIntegrations',
  'subscription.infinityFeatureExport',
] as const
